import { toast } from 'react-toastify';
import Axios from '../Axios';

export const getNotifications = async (page = 1) => {
    try {
        const res = await Axios.get(`/notifications?page=${page}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        });

        return res.data;
    } catch (error) {
        console.log('error', error);
        toast.warn('Something went wrong while fetching notifications');
    }
};

export const getUnreadNotificationCount = async () => {
    try {
        const res = await Axios.get('/notifications/unread-count', {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        });

        return res.data;
    } catch (error) {
        console.log('error', error);
        toast.warn('Something went wrong while fetching unread notification count');
    }
};

export const markNotificationAsRead = async (id) => {
    try {
        const res = await Axios.post(
            `/notifications/${id}/mark-as-read`,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token'),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.log('error', error);
        toast.warn('Something went wrong while marking notification as read');
    }
};

export const markAllNotificationsAsRead = async () => {
    try {
        const res = await Axios.post(
            `/notifications/mark-all-as-read`,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token'),
                },
            }
        );

        return res.data;
    } catch (error) {
        console.log('error', error);
        toast.warn('Something went wrong while marking all notifications as read');
    }
};
